import React from "react";
import SubjectTopics from "../subjectTopics"; // Import the SubjectTopics component

// Ratio Component
// This component renders a SubjectTopics component for the Ratio, Proportion & Rate of Change subject
const Ratio = () => <SubjectTopics subjectId={3} title="Ratio, Proportion & Rate of Change" />;

export default Ratio; // Export the Ratio component
